import { displayRole, type User } from 'shared/modelTypes/index';
import { Spacer } from './Spacer';
import { Badge } from './Badge';
import { Pen, X } from 'lucide-static';
import { Icon } from './Icon';
import { Modal, showModal } from './Modal';
import { Button } from './Button';
import { showToast, Toast } from './Toast';
import { navigate } from 'engine/router';
import { rpc } from 'src/backend';

type UserViewProps = {
	user: User;
};
export function UserView({ user }: UserViewProps) {
	const view: HTMLElement = (
		<div class="mx-auto max-w-xl rounded-lg bg-white p-4 shadow-lg dark:bg-gray-800">
			<div class="flex items-center justify-between">
				<div class="flex items-baseline gap-2">
					<h2 class="text-xl font-bold text-gray-800 dark:text-gray-100">
						{user.firstName} {user.lastName}
					</h2>
				</div>
				<Spacer />
				<Badge status="info">{displayRole(user.role)}</Badge>
			</div>
			<span class="mb-3 flex gap-1">
				<small class="text-gray-500 dark:text-gray-400">{user.email}</small>
			</span>
			<hr class="my-3 dark:border-gray-700" />
			<div class="flex gap-4">
				<Button mode="secondary" href={'/dashboard/users/edit/' + user._id?.split('/')[1]}>
					Edit
					<Icon icon={Pen} class="size-3" />
				</Button>
				<Button mode="tertiary" on:click={deleteUser}>
					Delete
				</Button>
			</div>
		</div>
	);

	async function deleteUser() {
		if (!user._id) return;

		if (
			await showModal(
				<Modal
					title="Delete user?"
					description="You are about to permanently remove this user. This cannot be undone."
					cancel="Cancel"
					confirm="Delete Permanently"
					dangerous
				/>,
			)
		) {
			view.style.pointerEvents = 'none';
			view.style.opacity = '0.6';
			const res = rpc.deleteUser.query(user._id!);
			// console.log('got res', res);
			navigate('/dashboard/users');
			showToast(<Toast icon={X} title="User deleted." />, 3000);
		}
	}

	return view;
}
